import React from 'react';

import { useSessionSettingsContext } from '@app/core/contexts/sessionSettings/SessionSettingsContext';
import { useWizardHeartbeat } from '@app/core/heartbeat/useWizardHeartbeat';

/**
 * HoC to wrap the component with the wizard heartbeat
 */
export const withWizardHeartbeat = (WrappedComponent: React.FC) => {
  const ComponentWithWizardHeartbeat: React.FC = () => {
    const userSessionExpirationInSecs = useSessionSettingsContext()?.userSessionExpirationInSecs;
    useWizardHeartbeat(userSessionExpirationInSecs);
    return <WrappedComponent />;
  };
  return ComponentWithWizardHeartbeat;
};

withWizardHeartbeat.displayName = 'WizardWithHeartbeat';
